<template>
  <div>
    <div class="flex flex-row gap-4 relative h-12 language-container">
      <div v-for="(locale, i) in locales" :key="locale">
        <button
            @click="toggleOrSelectLocale(locale)"
            class="language-button absolute transition-all duration-300"
            :class="locale === i18n.locale ? 'language-button-active z-50' : 'z-40'"
            :style="positions[i]"
        >
          {{ locale.toUpperCase() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Locale } from "~/lib/types";

const open = ref(false);
const locales: Locale[] = ["en", "de"];
const positions = computed(() => {
  return locales.map((_, i) => {
    return {
      right: open.value ? `${buttonSpacing * (locales.length - 1 - i)}rem` : "0",
    };
  });
});
const i18n = useI18nStore();

const buttonSpacing = 3;

const toggleOrSelectLocale = (locale: Locale) => {
  if (open.value && i18n.locale !== locale) {
    i18n.setLocale(locale);
    open.value = false;
  } else {
    open.value = !open.value;
  }
};
</script>

<style lang="postcss" scoped>
.language-button {
  @apply text-base flex items-center justify-center text-[#FF6436] font-bold;
  width: 40px;
  height: 40px;
  background-color: #1C1C1C;
  color: white;
}

.overlay-header{
  .language-button {
    background: #8C825C;
    border: #8C825C 1px solid;
  }
  .language-button-active {
    background: grey;
    color: #FFF9E2;
  }
}

.language-container {
  top: 0;
  right: 0;
}
.language-button-active {
  background-color: #1C1C1C;
}

.language-button {
  @apply transition-all duration-300;
  font-family: Montserrat, serif;
  font-weight: 400;
  font-size: 13px;
  border-radius: 50px;
  line-height: 19px;
  vertical-align: middle;
}
</style>
